import { validSeoPath } from 'shared/util/formatting';
import type { DestinationItem } from './ExpandableDestinationList';

const makeValidPath = (pathElements: (string | undefined)[]) =>
    pathElements
        .filter((pathElement) => pathElement !== undefined)
        .map((pathElement) => validSeoPath(pathElement))
        .join('/');

type FlightData = Record<string, { country: string; fromCities: string[] }>;
type DestinationData = Record<string, (string | { country: string; city?: string })[]>;

export const transformFlightDestinations = (data: FlightData): DestinationItem[] =>
    Object.entries(data).map(([toCity, cityData]) => ({
        title: `Fly til ${toCity}`,
        links: cityData.fromCities.map((fromCity) => ({
            label: `Fly fra ${fromCity} til ${toCity}`,
            href: `/reise/flybilletter/norge/${makeValidPath([fromCity, cityData.country, toCity])}/`,
        })),
    }));

export const transformDestinations = (data: DestinationData, pathPrefix: string): DestinationItem[] =>
    Object.entries(data).map(([toPlace, destinations]) => ({
        title: toPlace,
        links: destinations.map((dest) => {
            const country = typeof dest === 'string' ? toPlace : dest.country;
            const city = typeof dest === 'string' ? dest : dest.city;
            return {
                label: city || country,
                href: `/reise/${makeValidPath([pathPrefix, country, city])}/`,
            };
        }),
    }));
